import { useCallback, useEffect, useState } from 'react';
import DatosMaestrosService from '../../services/datosMaestrosService';

/**
 * Regímenes diferenciales activos del trámite de Jubilación (dato maestro), para el desplegable
 * del inicio del trámite y de la ficha. `agregarRegimen` suma el que se acaba de crear desde el
 * desplegable sin volver a pedir la lista (si ya estaba, no lo duplica).
 */
export default function useRegimenesJubilacion() {
    const [regimenes, setRegimenes] = useState([]);
    const [cargando, setCargando] = useState(false);

    useEffect(() => {
        let activo = true;
        setCargando(true);
        DatosMaestrosService.getRegimenesJubilacion(true)
            .then((res) => { if (activo) setRegimenes(Array.isArray(res.data) ? res.data : []); })
            .catch((err) => console.error('Error al cargar los regímenes de jubilación:', err))
            .finally(() => { if (activo) setCargando(false); });
        return () => { activo = false; };
    }, []);

    const agregarRegimen = useCallback((nuevo) => {
        if (!nuevo?.id) return;
        setRegimenes((prev) => (prev.some((r) => r.id === nuevo.id) ? prev : [...prev, nuevo]));
    }, []);

    return { regimenes, cargando, agregarRegimen };
}
